import { colorStrings, fontFamily } from "@hardware/Utilities/variables";
import baseTheme, { ThemeTypography } from "@insite/mobius/globals/baseTheme";
import { TypographyPresentationProps } from "@insite/mobius/Typography";

export const headingCommon: TypographyPresentationProps = {
    fontFamily,
    lineHeight: 1.2,
    weight: 700,
    color: colorStrings.textMain,
    transform: "none",
    mergeCss: true,
};

export const bodyCommon: TypographyPresentationProps = {
    fontFamily,
    size: "16px",
    lineHeight: 1.8,
    weight: 400,
    transform: "none",
    mergeCss: true,
    forwardAs: "span",
};

export const typography: ThemeTypography & { bodyBig: TypographyPresentationProps } = {
    h1: {
        ...baseTheme.typography.h1,
        ...headingCommon,
        size: "43px",
    },
    h2: {
        ...baseTheme.typography.h2,
        ...headingCommon,
        size: "32px",
    },
    h3: {
        ...baseTheme.typography.h3,
        ...headingCommon,
        size: "24px",
    },
    h4: {
        ...baseTheme.typography.h4,
        ...headingCommon,
        size: "18px",
    },
    h5: {
        ...baseTheme.typography.h5,
        ...headingCommon,
        size: "14px",
    },
    h6: {
        ...baseTheme.typography.h6,
        ...headingCommon,
        size: "12px",
        transform: "uppercase",
    },

    headerPrimary: {
        ...baseTheme.typography.headerPrimary,
        ...headingCommon,
    },
    headerSecondary: {
        ...baseTheme.typography.headerSecondary,
        ...headingCommon,
    },
    headerTertiary: {
        ...baseTheme.typography.headerTertiary,
        ...headingCommon,
    },

    body: {
        ...baseTheme.typography.body,
        ...bodyCommon,
        color: colorStrings.textMain,
    },
    p: {
        ...baseTheme.typography.p,
        ...bodyCommon,
        color: colorStrings.textMain,
    },
    legend: {
        ...baseTheme.typography.legend,
        ...bodyCommon,
        color: colorStrings.textMain,
        size: "12px",
    },

    /* Verndale Custom Typography */
    bodyBig: {
        ...baseTheme.typography.body,
        ...bodyCommon,
        color: colorStrings.textMain,
        size: "18px",
    },
};
